<template>
  <div class="d-question" ref="d_question" @mouseenter="isHovered = true" @mouseleave="isHovered = false">
    <div class="d-question__answer" ref="d_popover" :class="{'d-question__answer--show': isHovered}">
      <slot name="answer">
        <p>Her er svar på dine spørgsmål</p>
      </slot>
    </div>
    <svg width="16px" height="16px" viewBox="0 0 16 16">
      <g id="Artboard-2" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Group-2">
          <circle id="Oval-10" fill="#a2a3a6" cx="8" cy="8" r="8"></circle>
          <path
            d="M7.354,9.657 L7.354,9.294 C7.354,7.732 9.059,7.292 9.059,6.148 C9.059,5.51 8.652,5.191 8.014,5.191 C7.343,5.191 6.826,5.609 6.826,6.445 L5.473,6.445 C5.473,4.729 6.573,3.948 8.102,3.948 C9.389,3.948 10.533,4.608 10.533,6.005 C10.533,7.666 8.663,8.183 8.663,9.437 L8.663,9.657 L7.354,9.657 Z M7.156,11.373 C7.156,10.878 7.464,10.559 8.003,10.559 C8.509,10.559 8.85,10.878 8.85,11.34 C8.85,11.813 8.509,12.143 8.003,12.143 C7.464,12.143 7.156,11.813 7.156,11.373 Z"
            id="?" fill="#FFFFFF"></path>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>
import {createPopper} from '@popperjs/core'

export default {
  data () {
    return {
      isHovered: false
    }
  },
  methods: {
    createPopper () {
      let el = this.$refs.d_question
      let source = this.$refs.d_popover
      document.getElementById('djs-content-container').appendChild(source)
      createPopper(el, source, {
        placement: 'bottom-start',
        modifiers: [
          {
            name: 'offset',
            options: {
              offset: [5, 5]
            }
          }
        ]
      })
    }
  },
  mounted () {
    this.createPopper()
  },
  beforeDestroy () {
    // remove the dropdown from the DOM
    let source = this.$refs.d_popover
    if (source) {
      source.remove()
    }
  }
}
</script>

<style scoped>
.d-question {
  position: relative;
  display: flex;
  cursor: help;
}

.d-question__answer {
  z-index: 9999999;
  pointer-events: none;
  user-select: none;
  width: 200px;
  background-color: #ffffff;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: opacity 0.25s, transform 0.25s;
  font-weight: bold;
  opacity: 0;
}

.d-question__answer.d-question__answer--show {
  opacity: 1;
}

</style>



// WEBPACK FOOTER //
// DQuestionMark.vue?66b8f6e0